import React from 'react';
import { useDispatch } from 'react-redux';
import { setServerDown } from './redux/uiSlice';

const ServerDownScreen = () => {
  const dispatch = useDispatch();

  const handleRetry = () => {
    dispatch(setServerDown(false));
    window.location.reload();
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>⚠️</div>
        <h1 style={styles.title}>We're having trouble connecting</h1>
        <p style={styles.text}>
          Our service is temporarily unavailable. This isn't something you
          did — please try again in a moment.
        </p>
        <button style={styles.button} onClick={handleRetry}>
          Retry
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    position: 'fixed',
    inset: 0,
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f4f6f8'
  },
  card: {
    maxWidth: 420,
    padding: '40px 32px',
    textAlign: 'center',
    background: '#fff',
    borderRadius: 12,
    boxShadow: '0 8px 24px rgba(0,0,0,0.08)'
  },
  icon: {
    fontSize: 40,
    marginBottom: 16
  },
  title: {
    margin: '0 0 12px',
    fontSize: 20,
    fontWeight: 600,
    color: '#1a1a1a'
  },
  text: {
    margin: '0 0 24px',
    fontSize: 14,
    lineHeight: 1.5,
    color: 'var(--app-light-ink, #6b7280)'
  },
  button: {
    padding: '10px 24px',
    fontSize: 14,
    fontWeight: 600,
    color: '#fff',
    background: '#2563eb',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer'
  }
};

export default ServerDownScreen;
